module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Dedication"
    }
  }, [_c('p', {
    staticClass: "Dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("A sequel to "), _c('i', [_vm._v("Seven Seas, Nine Lives")]), _vm._v(" –"), _c('br'), _vm._v("more war experiences of"), _c('br'), _vm._v("Captain A W F ‘Alfie’ Sutton CBE DSC* RN")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d597cf6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Dedication.vue
// module id = 57
// module chunks = 0